<template>
  <div class="">
    <div class='goods_details'>
      <div class='goods_details_nav'>
        <div class='goods_details_nav_cell'>商品详情
            <div class='goods_details_nav_cell_traingle'></div>
        </div>
        <!--div class='goods_details_nav_cell'>规格参数
          <div class='goods_details_nav_cell_traingle'></div>
        </div-->
      </div>
      <div class='goods_details_pics'>
        <div>
        <img :src='image' v-for='image in images' class='goods_details_pic' />
        </div>
        <div class='goods_details_pics_hide' @click="goodsDetailShow">
          <div class='icon-top icon_top_position'></div>
          <span class='goods_details_btn'>收起商品详情</span>
        </div>

      </div>
 </div>
  </div>
</template>
<script type = "text/ecamscript-6">
export default {
  name:"goodsDetail",
  props:['images','goodsDetailShow'],
  data () {
    return{}
  },
  created() {
    //console.log(this.images)
    //console.log("ok")
  }

}
</script>
<style lang="stylus">
  .goods_details
    width: 100%
    margin-top: 10px
    background: #fff
    border-bottom: 1px solid #e5e5e5
    /*px*/
    .goods_details_nav
      width:100%
      height:72px
      border-right: 0px
      display: flex
      font-size: 24px
      color: #ff7400
      line-height: 72px
      box-sizing:border-box
      .goods_details_nav_cell
        flex: 1
        box-sizing: border-box
        line-height: 72px
        position: relative
        text-align: left
        text-indent:30px
        color:#666
        .goods_details_nav_cell_traingle
          display:none
        &.selected
          border-top: 6px solid #ff7400
          line-height: 60px
          color:#ff7400
          .goods_details_nav_cell_traingle
            display:block
        .goods_details_nav_cell_traingle
          width: 0;
          height: 0px;
          border: 10px solid transparent;
          border-top: 10px solid #ff7400;
          position: absolute;
          left: 50%;
          top:0px;
          transform: translateX(-50%)
    .goods_details_pics
      width: 100%
      .goods_details_pic
        width: 100%
    .goods_details_pics_hide
      padding: 10px 0
      color: #999
      .icon_top_position
        text-align: center
      .goods_details_btn
        width: 250px
        height: 60px
        line-height: 60px
        border: 1px solid #e5e5e5
        /*px*/
        border-radius: 30px
        font-size: 24px
        margin: 0 auto
        display:block
        text-align:center
</style>



// WEBPACK FOOTER //
// src/components/item/goodsDetail.vue